<template>
  <w-icon-wrapper
    :height='24'
    :width='24.11'
    icon-name='work-reserved-demand-icon'
    view-box='0 0 24.11 24'
  >
    <g
      id="_98_Vorgemerkt_Bedarf_Icon"
      data-name="98 Vorgemerkt Bedarf_Icon"
      transform="translate(-1039.695 -755)"
    >
      <path
        id="Pfad_55793"
        data-name="Pfad 55793"
        d="M14.028,24V20.193H.035V24H1.973V22.2H6.012V24H7.951V22.2h4.138V24Z"
        transform="translate(1039.695 755)"
        fill="currentColor"
      />
      <path
        id="Pfad_55794"
        data-name="Pfad 55794"
        d="M10.05,17.859H6.023V13.832H10.05Zm1-5.027H5.023v6.027H11.05Z"
        transform="translate(1039.695 755)"
        fill="currentColor"
      />
      <path
        id="Pfad_55795"
        data-name="Pfad 55795"
        d="M2.782,17.859H1V16.077H2.782Zm1-2.781H0V18.86H3.782Z"
        transform="translate(1039.695 755)"
        fill="currentColor"
      />
      <rect
        id="Rechteck_4035"
        data-name="Rechteck 4035"
        width="2.015"
        height="2.015"
        transform="translate(1051.748 771.844)"
        fill="currentColor"
      />
      <path
        id="Pfad_55796"
        data-name="Pfad 55796"
        d="M24.11,13.059l-4.443-3.014-4.444,3.014V0H24.11Z"
        transform="translate(1039.695 755)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconReservedDemand' };
</script>
